import { gql, Graph } from "~/Graph";
import { ID } from "~/ID";
import { Time } from "~/Time";

export type Lifecycle = { readonly lifecycle: Lifecycle.Submitted };
export namespace Lifecycle {
  export type Submitted = {
    readonly submitted: Time.DateTime & {
      readonly name?: string;
      readonly user?: ID;
    };
  };

  export type Created = {
    readonly created: Time.DateTime;
  };

  export namespace Created {
    export namespace Fragment {
      export const document = () => gql`
        fragment Created on Lifecycle__HasOne {
          lifecycle {
            created {
              dateTime
            }
          }
        }
      `;
    }

    export const decode = (encoded: {
      readonly lifecycle: { readonly created: { readonly dateTime: string } };
    }): Created => ({
      created: {
        dateTime: new Date(encoded.lifecycle.created.dateTime).valueOf(),
      },
    });
  }

  export namespace Submitted {
    export type Fragment = Graph.Generated.SubmittedFragment;
    export namespace Fragment {
      export const document = () => gql`
        fragment Submitted on Lifecycle__HasOne {
          lifecycle {
            submitted {
              dateTime
              actor {
                ... on Actor__Human {
                  name
                  userID
                }
              }
            }
          }
        }
      `;
    }

    export const decode = (encoded: Fragment): Lifecycle.Submitted => {
      const actor = encoded.lifecycle.submitted.actor;
      return {
        submitted: {
          dateTime: new Date(encoded.lifecycle.submitted.dateTime).valueOf(),
          name:
            "name" in encoded.lifecycle.submitted.actor
              ? encoded.lifecycle.submitted.actor.name
              : undefined,
          user:
            "userID" in actor && actor.userID
              ? { id: actor.userID }
              : undefined,
        },
      };
    };
  }
}
